import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Heart, X } from 'lucide-react'
import { Button } from '@/components/ui'

const STORAGE_KEY = 'scb-donate-banner-dismissed'

export function DonateBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY)
    if (!dismissed) {
      setVisible(true)
    }
  }, [])

  const dismiss = () => {
    setVisible(false)
  }

  const dismissForever = () => {
    localStorage.setItem(STORAGE_KEY, 'true')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="relative mx-6 md:mx-8 mt-4 rounded-lg border border-pink-500/30 bg-pink-500/5 p-4">
      <button
        onClick={dismiss}
        className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors"
      >
        <X className="h-4 w-4" />
      </button>
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 pr-6">
        <Heart className="h-5 w-5 text-pink-500 shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">
            Enjoying SCB|PHIL Terminal?{' '}
            <Link to="/donate" className="text-pink-400 hover:text-pink-300 underline underline-offset-2">
              Consider donating
            </Link>
            {' '}to support development.
          </p>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={dismissForever}
          className="text-xs text-muted-foreground shrink-0"
        >
          Don't show again
        </Button>
      </div>
    </div>
  )
}
